module.exports = __webpack_public_path__ + "img/lock.bc1a8000.svg";